import MyImg from "../assets/blog-img.jpg"
import YoutubeLogo from "../assets/youtube-logo.png"
import GithubLogo from "../assets/github-logo.png"
import LinkedinLogo from "../assets/linked-logo.jpg"
import TgLogo from "../assets/tgg-logo.png"
import { Link } from 'react-router-dom'

function Main() {
    return (
        <div className="main container general-margin_top">
            <div className="main-wrapper container d-flex align-items-center">
                <img className="myimg" src={MyImg} alt="Myimg" width={180} />
                <div>
                    <h3 className="main-username">Abbos Shamsiddin</h3>
                    <p className="main-user-position">Lawyer</p>
                    <div className="logos d-flex align-items-center">
                        <a className="me-3" href="https://www.youtube.com/channel/UCGiIH3tvVPG6Eq9CZYTkVXw" target="_blank" rel="noopener noreferrer">
                            <img className="YoutubeLogo" src={YoutubeLogo} alt="YoutubeLogo" width={25} height={25} />
                        </a>
                        <a className="me-3" href="https://www.instagram.com/abbos_shamsiddin/" target="_blank" rel="noopener noreferrer">
                            <img className="GithubLogo" src={GithubLogo} alt="GithubLogo" width={24} height={24} />
                        </a>
                        <a className="me-3" href="https://www.linkedin.com/in/abbosshamsiddin/" target="_blank" rel="noopener noreferrer">
                            <img className="LinkedinLogo" src={LinkedinLogo} alt="LinkedinLogo" width={22} height={22} />
                        </a>
                        <a className="me-3" href="https://t.me/Abbos_Shamsiddin" target="_blank" rel="noopener noreferrer">
                            <img className="TgLogo" src={TgLogo} alt="TgLogo" width={25} height={25} />
                        </a>
                    </div>
                </div>
            </div>

            <p className="main-description">The more laws, the less justice</p>

            <div className="main-btns">
                <Link className="main-btn1 btn btn-primary" to="/blog">Read Blog</Link>
                <Link className="main-btn2 btn btn-outline-secondary" to="/about">About Me</Link>
            </div>

            <p className="main-footer">© 2022 shamsiddinov.uz</p>
        </div>
    );
}

export default Main;
